export { default } from './getStructuredData'
